module.exports = "<app-homepage></app-homepage> \n\n<router-outlet></router-outlet>\n"